import React, { useRef, useState } from 'react'
import { CLASS_PREFIX } from 'src/constants'
import './code_input.scss'

const cls = `${CLASS_PREFIX}code-input`

type IProps = {
  digits: number
  label?: string
  value: string
  onChange: (value: string) => void
}

export const CodeInput: React.FC<IProps> = ({ digits, label, value, onChange }) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [focused, setFocused] = useState(false)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const filtered = e.target.value.replace(/\D/g, '').slice(0, digits)
    onChange(filtered)
  }

  const handleContainerClick = () => {
    inputRef.current?.focus()
  }

  return (
    <div className={cls}>
      {label && <label className={`${cls}__label`}>{label}</label>}
      <div className={`${cls}__digits`} onClick={handleContainerClick}>
        <input
          ref={inputRef}
          className={`${cls}__input`}
          type="text"
          inputMode="numeric"
          autoComplete="one-time-code"
          maxLength={digits}
          value={value}
          onChange={handleChange}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
        />
        {Array.from({ length: digits }, (_, i) => (
          <div
            key={i}
            className={`${cls}__digit ${focused && i === value.length ? `${cls}__digit--active` : ''}`}
          >
            {value[i] ?? ''}
          </div>
        ))}
      </div>
    </div>
  )
}
